import type { $ZodIssue, ParseContext } from 'zod/v4/core';

export const getI18nErrorMap = (
  translateFn: (error: string) => string,
): ParseContext<$ZodIssue>['error'] => {
  return (error) => {
    const fieldName = String(error.path?.[error.path.length - 1]);

    let errorKey = '';

    switch (error.code) {
      case 'invalid_type':
      case 'too_small':
        errorKey = `${fieldName}Required`;
        break;

      case 'invalid_format':
        if (error.format === 'email') {
          errorKey = `${fieldName}Invalid`;
        }

        break;

      case 'too_big':
        errorKey = 'tooLong';
        break;

      case 'custom':
        if (error.message) {
          errorKey = error.message;
        }

        break;

      case 'unrecognized_keys':
      case 'invalid_union':
      case 'not_multiple_of':
      default:
        break;
    }

    if (!errorKey.length || !translateFn(errorKey)) {
      return { message: error.message ?? 'Unknown error' };
    }

    return { message: translateFn(errorKey) };
  };
};
